import { render, staticRenderFns } from "@/components/Layout/Menu/Reportes/Reportes_veralia/Reportes_veralia.html?vue&type=template&id=442b6831&scoped=true&"
import script from "@/components/Layout/Menu/Reportes/Reportes_veralia/Reportes_veralia.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Reportes/Reportes_veralia/Reportes_veralia.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Reportes/Reportes_veralia/Reportes_veralia.css?vue&type=style&index=0&id=442b6831&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442b6831",
  null
  
)

export default component.exports